import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-p8-documents-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  standalone: false
})
export class DocumentsErrorPageComponent {
  @Input() messageHeader = '';
  @Input() messageBody = '';
}
